export default [
  {
    title: 'Synchronisation',
    icon: 'RefreshCwIcon',
    roles: ['admin_developer'],
    children: [
      {
        title: 'Correction référence',
        icon: 'Edit3Icon',
        route: 'sync-reference-correction',
        roles: ['admin_developer'],
      },
    ],
  },
  {
    title: 'Gestion des Factures Fournisseur',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Liste des Factures',
        route: 'invoice-list-direx',
        icon: 'ListIcon',
      },
      {
        title: 'Créer une Facture',
        route: 'invoice-create-direx',
        icon: 'PlusCircleIcon',
      },
    ],
  },
  {
    title: 'Paramètres',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Configuration Authentification',
        route: 'parameters',
        icon: 'ShieldIcon',
      },
      {
        title: 'Bordereaux société',
        route: 'company-bordereau-display-parameters',
        icon: 'FileTextIcon',
      },
    ],
  },
]
